// Site-wide constants and content
export const SITE = {
    name: "Fundación Formar Estructura",
    short: "Formar Estructura",
    tagline: "Transformando vidas desde el territorio y la acción social",
    description:
        "Más de 15 años trabajando por el desarrollo integral de niños, jóvenes y familias en Ibagué y Tolima.",
    address: "Cra 5 #40-90 Apartamento 401 — Edificio Jesús Pérez Rayo (Sede Administrativa), Ibagué, Tolima — Colombia",
    city: "Ibagué, Tolima — Colombia",
    phone: "+57 318 318 4705",
    phoneRaw: "3183184705",
    email: "formarestructura2014@hotmail.com",
    facebook: "https://www.facebook.com/share/18QEGo7PHo/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/formar_estructura?igsh=MWkwM294dHFvOHJwbA%3D%3D&utm_source=qr",
    foundedYear: 2014,
    bank: {
        bankName: "Bancolombia",
        accountType: "Cuenta de Ahorros",
        accountNumber: "Solicítela escribiendo a formarestructura2014@hotmail.com",
        nit: "Disponible bajo solicitud",
        beneficiary: "Fundación Formar Estructura",
    },
};

export const IMAGES = {
    hero_topo: "https://static.prod-images.emergentagent.com/jobs/1c15f128-0fc0-4cb0-8b5c-449e5dcc3a30/images/63b52dbd544c9c42c7ebb531b2b5113578e43070a5b914f7aa8aec7af8beed7a.png",
    watercolor: "https://static.prod-images.emergentagent.com/jobs/1c15f128-0fc0-4cb0-8b5c-449e5dcc3a30/images/ac4d6cffe1f6a4173e75cdfd245de62d41ba417c5c352ebc30e016e88533b8a9.png",
    volunteers_christmas: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/fv08078y_IMG_7363.JPG",
    elderly_care: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/ihxyggxt_IMG_7268.jpg",
    children_community: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/omki1hdf_IMG_2524.JPG",
    child_gift: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/5z3bqbg4_IMG_0156.jpeg",
    volunteer_painting: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/7vqh7cis_IMG_0114.jpeg",
};

export const NAV_LINKS = [
    { to: "/", label: "Inicio" },
    { to: "/quienes-somos", label: "Quiénes Somos" },
    { to: "/impacto", label: "Impacto" },
    { to: "/voluntariado", label: "Voluntariado" },
    { to: "/transparencia", label: "Transparencia" },
    { to: "/blog", label: "Blog" },
    { to: "/contacto", label: "Contacto" },
];

export const VALUES = [
    {
        title: "Dignidad",
        text: "Reconocemos en cada persona su capacidad de transformación y su valor inherente como agente de cambio en su propia historia.",
    },
    {
        title: "Esperanza",
        text: "Creemos en el potencial inagotable de las comunidades y en su capacidad de imaginar futuros distintos.",
    },
    {
        title: "Transparencia",
        text: "Rendimos cuentas con apertura y rigurosidad. La confianza se construye con hechos verificables.",
    },
    {
        title: "Territorio",
        text: "Trabajamos desde el contexto, escuchando y co-creando con las comunidades del Tolima.",
    },
    {
        title: "Cultura",
        text: "El arte, la música y los intercambios culturales son herramientas poderosas de desarrollo humano.",
    },
    {
        title: "Compromiso",
        text: "Procesos sostenibles, no soluciones temporales. Acompañamos a largo plazo.",
    },
];

export const PROJECTS = [
    {
        slug: "refuerzo-escolar",
        title: "Refuerzo escolar",
        category: "Educación",
        summary: "Apoyo académico personalizado para niños, niñas y adolescentes en áreas básicas, fortaleciendo hábitos de estudio y mejorando su rendimiento escolar.",
        impact: "+ 1.200 niños beneficiados",
        image: "child_gift",
    },
    {
        slug: "acompanamiento-psicosocial",
        title: "Acompañamiento psicosocial",
        category: "Bienestar emocional",
        summary: "Atención emocional y orientación a niños, adolescentes y familias para fortalecer su desarrollo integral y prevenir situaciones de riesgo.",
        impact: "+ 500 familias acompañadas",
        image: "volunteer_painting",
    },
    {
        slug: "interaccion-cultural",
        title: "Interacción cultural",
        category: "Cultura",
        summary: "Espacios donde niños y jóvenes acceden al arte, la música y experiencias culturales que amplían su horizonte de oportunidades.",
        impact: "+ 8.000 experiencias culturales",
        image: "children_community",
    },
    {
        slug: "jornadas-recreativas",
        title: "Jornadas recreativas",
        category: "Recreación",
        summary: "Actividades lúdicas y deportivas que fomentan la integración, el juego sano y el aprovechamiento positivo del tiempo libre.",
        impact: "+ 5.000 niños y familias por año",
        image: "child_gift",
    },
    {
        slug: "escuela-de-padres",
        title: "Escuela de padres",
        category: "Familia",
        summary: "Formación a madres, padres y cuidadores en pautas de crianza, comunicación familiar y construcción de entornos protectores.",
        impact: "+ 300 familias formadas",
        image: "volunteers_christmas",
    },
    {
        slug: "integracion-adulto-mayor",
        title: "Jornadas de integración con adulto mayor",
        category: "Comunidad",
        summary: "Encuentros intergeneracionales que fortalecen vínculos, dignidad y bienestar de los adultos mayores junto a niños y jóvenes voluntarios.",
        impact: "+ 350 adultos mayores",
        image: "elderly_care",
    },
];

export const ALLIES = [
    { name: "Fundación Bolívar Davivienda", program: "Programa Aflora" },
    { name: "Alcaldía de Ibagué", program: "Convenios sociales" },
    { name: "Gobernación del Tolima", program: "Iniciativas culturales" },
    { name: "Universidad del Tolima", program: "Investigación y voluntariado" },
    { name: "Comfenalco Tolima", program: "Programas comunitarios" },
    { name: "Voluntarios Internacionales", program: "Intercambio cultural" },
    { name: "Centro Comercial La Estación", program: "Aliado estratégico" },
    { name: "Indeportes", program: "Deporte y recreación" },
    { name: "Instituto Colombiano de Bienestar Familiar", program: "Protección de la infancia" },
    { name: "Ejército Nacional de Colombia", program: "Apoyo comunitario" },
    { name: "Secretaría de Inclusión Social y Enfoque Diferencial", program: "Alianza institucional" },
    { name: "Bendito Manjar", program: "Aliado en nutrición" },
    { name: "PowerChina Colombia", program: "Aliado empresarial" },
    { name: "Policía Nacional de Colombia", program: "Apoyo institucional" },
    { name: "Universidad Cooperativa de Colombia", program: "Aliado académico" },
];

export const TESTIMONIALS = [
    {
        quote: "Antes pensaba que mi futuro estaba escrito. La Fundación me ayudó a descubrir que podía pintar, soñar y enseñarle a otros. Hoy soy líder en mi barrio.",
        author: "Camila R.",
        role: "Egresada del programa Talentos en Acción",
    },
    {
        quote: "Llegué de Alemania a hacer voluntariado por seis meses. Me llevé el doble de lo que entregué. Ibagué te transforma.",
        author: "Lukas M.",
        role: "Voluntario internacional",
    },
    {
        quote: "Viví de cerca su labor y sentí esperanza: no solo ayudan, transforman vidas con amor real en cada comunidad de Ibagué.",
        author: "Doña Marlene",
        role: "Madre de familia, Comuna 8 — Ibagué",
    },
];

export const VOLUNTEER_AREAS = [
    "Educación y refuerzo escolar",
    "Arte, música y cultura",
    "Recreación y deporte",
    "Comunicaciones y diseño",
    "Logística de eventos",
    "Acompañamiento a adultos mayores",
    "Voluntariado internacional",
    "Gestión de proyectos",
];

export const AVAILABILITY_OPTIONS = [
    "Algunas horas a la semana",
    "Fines de semana",
    "Eventos puntuales",
    "Tiempo completo",
    "Voluntariado internacional",
];
